module.exports = __webpack_public_path__ + "static/media/LeftoverSalmonreuniontourBrooklynBowl9-23-2001Handdrawn4colorscreenprint.3bf883a9.webp";